export const CLIENT = {
  CODE: {
    Organization: "00030304",
    Business: "00030305",
  },
};
